import Intervals from '../../../base/errors/airdome/Intervals';

const intervals: Intervals = {
  GeneralError: 'Bei der Bearbeitung des Luftkuppels trat ein Fehler auf.'
};

export default intervals;
